import { Provider } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { USStates } from '../utils/us-states';
import { auStates } from '../utils/au-states';
import { AU_I18N_OPTIONS, I18N_OPTIONS_TOKEN, I18nOptions, i18nOptionsFor, PRODUCT_DEFAULT_COUNTRY_CODE, US_I18N_OPTIONS } from './i18n-options-token';
import { AU_STATE_PROVINCE_VALIDATORS, STATE_PROVINCE_TOKEN, STATE_PROVINCE_VALIDATOR_TOKEN, US_STATE_PROVINCE_VALIDATORS, stateProvinceListFor, stateProvinceValidatorsFor } from './state-province.token';
import { AU_POSTAL_CODE_VALIDATORS, POSTAL_CODE_VALIDATOR_TOKEN, US_POSTAL_CODE_VALIDATORS, postalCodeValidatorsFor } from './postal-code.token';

interface CountryLocaleDefaults {
    i18n: I18nOptions;
    states: string[];
    stateValidators: ValidatorFn[];
    postalValidators: ValidatorFn[];
}

const COUNTRY_LOCALE_DEFAULTS: Record<'US' | 'AU', CountryLocaleDefaults> = {
    US: { i18n: US_I18N_OPTIONS, states: USStates, stateValidators: US_STATE_PROVINCE_VALIDATORS, postalValidators: US_POSTAL_CODE_VALIDATORS },
    AU: { i18n: AU_I18N_OPTIONS, states: auStates, stateValidators: AU_STATE_PROVINCE_VALIDATORS, postalValidators: AU_POSTAL_CODE_VALIDATORS },
};

/**
 * Provides the country-driven locale tokens for an app. The country getter is read
 * synchronously at bootstrap and values fall back to the product default country.
 */
export function provideCountryLocale(countryGetter: () => string | null, defaultCountry: 'US' | 'AU'): Provider[] {
    const defaults = COUNTRY_LOCALE_DEFAULTS[defaultCountry];
    return [
        { provide: I18N_OPTIONS_TOKEN, useFactory: (): I18nOptions => i18nOptionsFor(countryGetter(), defaults.i18n) },
        { provide: STATE_PROVINCE_TOKEN, useFactory: (): string[] => stateProvinceListFor(countryGetter(), defaults.states) },
        { provide: STATE_PROVINCE_VALIDATOR_TOKEN, useFactory: (): ValidatorFn[] => stateProvinceValidatorsFor(countryGetter(), defaults.stateValidators) },
        { provide: POSTAL_CODE_VALIDATOR_TOKEN, useFactory: (): ValidatorFn[] => postalCodeValidatorsFor(countryGetter(), defaults.postalValidators) },
        { provide: PRODUCT_DEFAULT_COUNTRY_CODE, useValue: defaultCountry },
    ];
}
